export default __webpack_public_path__ + "static/media/logo.e9f47a23.png";